import { render, staticRenderFns } from "./UploadButton.vue?vue&type=template&id=1f49bc91&scoped=true&"
import script from "./UploadButton.ts?vue&type=script&lang=ts&"
export * from "./UploadButton.ts?vue&type=script&lang=ts&"
import style0 from "./UploadButton.vue?vue&type=style&index=0&id=1f49bc91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f49bc91",
  null
  
)

export default component.exports